__turbopack_context__.v({
  "accordionSlideOverwrite": "organization-module-scss-module__FVijOa__accordionSlideOverwrite",
  "content": "organization-module-scss-module__FVijOa__content",
  "fadeIn": "organization-module-scss-module__FVijOa__fadeIn",
  "fadeOut": "organization-module-scss-module__FVijOa__fadeOut",
  "headingContainer": "organization-module-scss-module__FVijOa__headingContainer",
  "headingRow": "organization-module-scss-module__FVijOa__headingRow",
  "headingTitle": "organization-module-scss-module__FVijOa__headingTitle",
  "hostedEvents": "organization-module-scss-module__FVijOa__hostedEvents",
  "layout": "organization-module-scss-module__FVijOa__layout",
  "mainContent": "organization-module-scss-module__FVijOa__mainContent",
  "mobileEvents": "organization-module-scss-module__FVijOa__mobileEvents",
  "orgAvatar": "organization-module-scss-module__FVijOa__orgAvatar",
  "orgAvatarImage": "organization-module-scss-module__FVijOa__orgAvatarImage",
  "page": "organization-module-scss-module__FVijOa__page",
  "pageInner": "organization-module-scss-module__FVijOa__pageInner",
  "paragraph": "organization-module-scss-module__FVijOa__paragraph",
  "scaleIn": "organization-module-scss-module__FVijOa__scaleIn",
  "scaleOut": "organization-module-scss-module__FVijOa__scaleOut",
  "sectionHeading": "organization-module-scss-module__FVijOa__sectionHeading",
  "shareButton": "organization-module-scss-module__FVijOa__shareButton",
  "sidebar": "organization-module-scss-module__FVijOa__sidebar",
  "sponsoredEvents": "organization-module-scss-module__FVijOa__sponsoredEvents",
  "zoomIn": "organization-module-scss-module__FVijOa__zoomIn",
  "zoomOut": "organization-module-scss-module__FVijOa__zoomOut",
});
